import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-5 py-24">
      <div className="max-w-lg w-full text-center rounded-3xl border border-slate-700/60 bg-obsidian-800/60 p-10">
        <div className="flex justify-center mb-6">
          <LogoMark className="w-14 h-14" />
        </div>
        <h1 className="font-display text-3xl font-bold text-white" data-testid="cancel-heading">
          Checkout cancelled
        </h1>
        <p className="text-slate-400 mt-4 leading-relaxed">
          No charge was made. Whenever you're ready, the Business Growth Assessment will be waiting —
          start with confidence, protected by our 7-Day Money-Back Guarantee.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-9">
          <Link
            data-testid="payment-cancel-retry-link"
            to="/#assessment"
            className="rounded-full bg-gold text-obsidian font-display font-bold px-8 py-4 hover:bg-gold-bright transition-colors"
          >
            View Assessment Offers
          </Link>
          <Link
            data-testid="payment-cancel-home-link"
            to="/"
            className="rounded-full border border-slate-600 text-slate-200 font-display font-bold px-8 py-4 hover:border-gold hover:text-gold transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
